import React from 'react';

import {
  StyledBody,
  StyledButton,
  StyledDialog,
  StyledHeader,
  StyledOutlineButton,
  StyledPicture,
  StyledTextOnlyButton,
} from './actions-modal.styled';
import { IActionsModalProps } from './types';

const ActionsModal = ({
  actions,
  bodyText,
  testID,
  headerText,
  headerImage,
  image,
  imageAlt = '',
  modalAppearanceEventMessage,
}: IActionsModalProps) => {
  const Header = () => (
    <>
      {!!headerImage && <StyledPicture image={headerImage} alt={imageAlt} />}
      {!!headerText && <StyledHeader>{headerText}</StyledHeader>}
    </>
  );
  const Body = () => <StyledBody>{bodyText}</StyledBody>;
  const Actions = () => (
    <>
      {actions.map(
        ({
          dataTestId: actionDataTestId,
          actionLabel,
          actionHandler,
          textOnly = false,
          outline = false,
        }) => {
          let BtnComponent = StyledButton;
          if (textOnly) {
            BtnComponent = StyledTextOnlyButton;
          } else if (outline) {
            BtnComponent = StyledOutlineButton;
          }
          return (
            <BtnComponent
              key={actionLabel}
              testID={actionDataTestId}
              onPress={actionHandler}
              width="full"
              marginTop="$2"
            >
              {actionLabel}
            </BtnComponent>
          );
        }
      )}
    </>
  );

  return (
    <StyledDialog
      testID={testID}
      headingComponent={<Header />}
      image={!!image && <StyledPicture image={image} alt={imageAlt} />}
      bodyComponent={<Body />}
      actions={<Actions />}
      modalAppearanceEventMessage={modalAppearanceEventMessage}
      showDialog
    />
  );
};

export default ActionsModal;
